import React from 'react';

import { RangeFilter } from 'components/Filter';

import { FilterProps } from './index';

type Props = {
  value: [nil | number | string, nil | number | string];
} & FilterProps;

const Quantity = (props: Props) => {
  let value = props.value;
  value = !value ? [null, null] : value;

  return <RangeFilter {...(props as any)} value={value} type={'number'} />;
};

export { Quantity };
